// removed by extract-text-webpack-plugin
module.exports = {"base":"Language_base--RAwKW","base__checked":"Language_base__checked--2brG8","baseChecked":"Language_base__checked--2brG8","title":"Language_title--1KMsh"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Filters/components/Language/Language.scss
// module id = 2279
// module chunks = 11